import { NotiDataType } from "@/core/models/notification";
import { Dispatch, SetStateAction, createContext } from "react"

export enum NotificationActions {
  OPEN_DETAIL = "OPEN_DETAIL",
  OPEN_VIEW_ALL = 'OPEN_VIEW_ALL',
  OPEN_MODAL_CONFIRM = 'OPEN_MODAL_CONFIRM'
}

export interface NotificationModal {
  openConfirmModal: boolean;
  action: string;
  dataNotification: NotiDataType[];
  setAction: Dispatch<SetStateAction<string>>;
  setOpenConfirmModal: Dispatch<SetStateAction<boolean>>;
  setDataNotification: Dispatch<SetStateAction<NotiDataType[]>>;
}



const NotificationContext = createContext<NotificationModal>({
  openConfirmModal: false,
  action: '',
  dataNotification: [],
  setOpenConfirmModal: () => null,
  setAction: () => null,
  setDataNotification: () => null
})

export default NotificationContext
